module.exports = __webpack_public_path__ + "static/assets/ef281ab2c4ac1113a72ef1c33b60519a.svg";